import SwCheckbox from './sw-checkbox.vue';
export {
  SwCheckbox,
};
